export class UnsavedChangesManager {
    hasUnsavedChanges: boolean = false;
    clearCb?: () => void;
    saveCb?: () => void;
    /** Noun used by the generic UnsavedChangesConfirm modal's copy (e.g. "test", "evaluation model"). Defaults to "test" there when unset. */
    subject?: string;

    beforeUnloadHandler = (event: any) => {
        event.preventDefault();
    };

    declareUnsavedChanges = (clearCb?: () => void, saveCb?: () => void, subject?: string) => {
        window.addEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = true;
        this.clearCb = clearCb;
        this.saveCb = saveCb;
        this.subject = subject;
    }

    declareNoUnsavedChanges = () => {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = false;
        this.clearCb = undefined;
        this.saveCb = undefined;
        this.subject = undefined;
    }

    clearAndLeave = () => {
        if (this.clearCb) {
            this.clearCb();
        }
        this.leave();
    }

    saveAndLeave = () => {
        if (this.saveCb) {
            this.saveCb();
        }
        this.leave();
    }

    leave = () => {
        window.removeEventListener("beforeunload", this.beforeUnloadHandler);
        this.hasUnsavedChanges = false;
        this.clearCb = undefined;
        this.saveCb = undefined;
        this.subject = undefined;
    }
}

export const unsavedChangesManager = new UnsavedChangesManager();
